import { useGetBonDeCommandes } from "modules/bonDeCommande/api";
import { useEffect, useState } from "react";
import { BonDeCommande } from "modules/bonDeCommande/types/bonDeCommande.interface";
import BonDeCommandeTable, {
  RowObjBonDeCommande,
} from "../default/components/bonDeCommandeTable";

const AllBonDeCommandes = () => {
  const [filters, setFilters] = useState({
    dateRange: null,
    status: null,
    client: null,
  });
  const [searchName, setSearchName] = useState<string | undefined>(undefined);
  const {
    data,
    hasNextPage,
    fetchNextPage,
    fetchPreviousPage,
    isLoading,
    refetch,
  } = useGetBonDeCommandes(searchName, filters);
  const [currentPage, setCurrentPage] = useState(1);
  const flatData = data?.pages[currentPage - 1]?.data ?? [];

  const handleFormatData = (data: BonDeCommande[]): RowObjBonDeCommande[] => {
    return data.map((item) => ({
      _id: item._id,
      workspaceId: item.workspaceId,
      clientId: item.clientId,
      createdAt: item.createdAt,
      totalTTC: item.totalTTC,
      totalHT: item.totalHT,
      dueDate: item.dueDate,
      updatedAt: item.updatedAt,
      status: item.status,
      archived: item.archived,
      lineItems: item.lineItems,
      documentNumber: item.documentNumber,
      client: item.client,
    }));
  };

  useEffect(() => {
    refetch();
  }, [filters, refetch]);

  const handleFetchNextPage = () => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFetchPrevPage = () => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <div className="mt-5">
        <BonDeCommandeTable
          tableData={handleFormatData(flatData)}
          searchName={searchName}
          setSearchName={setSearchName}
          currentPage={currentPage}
          totalPage={data?.pages[0].count}
          hasNextPage={hasNextPage}
          handleFetchNextPage={handleFetchNextPage}
          handleFetchPrevPage={handleFetchPrevPage}
          setFilters={setFilters}
          filters={filters}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default AllBonDeCommandes;
